if (window.location.pathname.includes('/collections/') && !window.scrollObserverExecuted) {
  window.scrollObserverExecuted = true
  if (sessionStorage.getItem('collectionScrollPosition')) {
    history.scrollRestoration = 'manual';
  } else {
    history.scrollRestoration = 'auto';
  }

  document.addEventListener('click', function (e) {
    const productLink = e.target.closest('a[href*="/products/"]');
    if (!productLink) return;

    sessionStorage.setItem('collectionScrollPosition', window.scrollY);
  });

  window.addEventListener('DOMContentLoaded', function () {

    const savedScroll = parseInt(sessionStorage.getItem('collectionScrollPosition'));
    if (!savedScroll) return;

    const container = document.querySelector('.collection__infinite-container');
    if (!container) return;

    let attempts = 0;
    const maxAttempts = 5;

    function canReachScroll() {
      const maxScrollable =
        document.documentElement.scrollHeight - window.innerHeight;

      return savedScroll <= maxScrollable;
    }

    function tryRestore() {
      window.scrollTo(0, savedScroll);

      if (canReachScroll()) {
        observer.disconnect();
        sessionStorage.removeItem('collectionScrollPosition');
        return true;
      }

      return false;
    }

    if (tryRestore()) return;

    const observer = new MutationObserver(() => {
      if (tryRestore()) return;

      if (attempts >= maxAttempts) {
        observer.disconnect();
        return;
      }

      attempts++;

      if (typeof window.loadMoreCardsPLP === 'function') {
        window.loadMoreCardsPLP();
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: false
    });

    if (typeof window.loadMoreCardsPLP === 'function') {
      attempts++;
      window.loadMoreCardsPLP();
    }
  });
}